module.exports = __webpack_public_path__ + "cae67100d6627b43deb1cc24dac69bb7.png";